import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.onSearchChange = props.onSearchChange;
  }

  render() {
    let search;
    if(this.props.showSearch) {
      search = (
        <form class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            placeholder="Search for Companies"
            aria-label="Search"
            onChange={this.onSearchChange}
            onKeyPress={e => {
              if (e.key === 'Enter') e.preventDefault();
            }}
          />
        </form>
      )
    } else {
      search = (<></>)
    }
    return (
      <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <button 
          class="navbar-toggler"
          type="button"
          data-toggle="collapse" 
          data-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
          <a class="navbar-brand" href="#"> Berlin's IT companies</a>
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <li class="nav-item">
              <Link class="nav-link" to="./companies">List View</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="./add">Add a company</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="./jobs">Jobs</Link>
            </li>
          </ul>
        </div>
        {search}
      </nav>
    );
  }
}

const mapStateToProps = state => {
  return {
    showSearch: state.showSearch
  }
}

export default connect(mapStateToProps)(NavBar);
